import {
  ChangeDetectionStrategy,
  Component,
  Input,
  NgModule,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterStaticLinkDirectiveModule } from '@icilalune/utils';
import { MatIconModule } from '@angular/material/icon';
import { MainMenuItem } from '@nx-icilalune/data/icilalune/types';
import { SvgIconComponentModule } from '@nx-icilalune/icilalune/media';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'i2l-ui-menu-item-link',
  template: `
    <ng-container *ngIf="menuItem">
      <a class="lune-btn prefix-icon" [routerStaticLink]="menuItem.path">
        <ng-container *transloco="let t">
          <i2l-svg-icon [icon]="'listing'"></i2l-svg-icon>
          <span
            [innerHTML]="
              showMenuItemLabel ? menuItem.title : t('actions.see-all')
            "
          ></span>
        </ng-container>
      </a>
    </ng-container>
  `,
  styleUrls: ['./menu-item-link.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemLinkComponent {
  @Input()
  menuItem: MainMenuItem | undefined;

  @Input()
  showMenuItemLabel = false;
}

@NgModule({
  imports: [
    CommonModule,
    RouterStaticLinkDirectiveModule,
    MatIconModule,
    SvgIconComponentModule,
    TranslocoModule,
  ],
  declarations: [MenuItemLinkComponent],
  exports: [MenuItemLinkComponent],
})
export class MenuItemLinkComponentModule {}
